var _ = require('underscore'),
    fvChannel = require('glRadio').channel('FV'),
    CoordinateNote = require('../base'),
    RedactionNoteView = require('../../../../../../views/note/redaction/view'),// for now using one: would need to refactor ViewConstructor to accept function (and know diff btn constructor)
    RedactionShapeView = require('../../../../../../../canvas/views/shape/redaction/redactionShape'),
    FloatingRedactionShapeView = require('../../../../../../../canvas/views/shape/redaction/floatingCodes/shapeView'),
    CoordinateRedactionShapeModel = require('../../../../../../../canvas/models/coordinate/redaction/redaction'),
    FloatingCodesShapeModel = require('../../../../../../../canvas/models/coordinate/redaction/floating/shapeModel');

/*
* For ease in facilitating conversion from floating to non-floating codes,
* only use one model and switch track for the shape views and models.
* ( Encountered reference (to other objects) & other issue when trying to create new note models instead of just switch tracking
* off the noteType and isConvertingToFloatingCodes.  The different shape models and views do work well however --
* it's a cleaner process or reRendering the shapes on the canvas, from which the constructor fn are called ).
* */

module.exports = CoordinateNote.extend({

    SUPPORTS_FIND_AND_REDACT: true,

    ViewConstructor: RedactionNoteView,
    init: 'D', // Floating is 'B'
    desc: 'Redaction',
    createHotKey: 'r',
    actionTitle: 'Redact',
    iconClass: 'icon-doc-text-inv',
    autoDisplayApplies: false,
    subTypes: ['rect', 'poly'],
    defaultShapeColor: '#ff0000',

    initialize: function( attrs, options ) {

        // Here for explicity so we can see this variable explicitly exists on here
        this.isConvertingToFloatingCodes = false;

        /*
        * Flag to prevent creating floating codes on Cold Pages.
        * Only set in model parse when creating a new note (below -- passed from options).
        * Not necessary to define here but left for clarity.
        * The default is really 'false' (it starts undefined).
        * Necessary to persist between note model creation and save ( after which parse calls init, so don't set back to false in here );
        * No notes read from the database should ever be floating if created on cold pages.
        * Defining this on the constructor is a better way but would require a refactor the note model.
        * Clearer options to accomplish this include utilizing the model's collection post save or,
        * injecting vChannel to determine if the page is cold from the pageId attribute.
        * */
        this.parentPageIsCold = this.parentPageIsCold;

        CoordinateNote.prototype.initialize.apply( this, arguments );

    },

    parse: function(attrs, options) {


        // cache some values as inst variables on the model
        // must reset them first (not clearing on modify, so do here)
        this.listOfReasonCodesForNoteView = null;
        this.uniqueStringOfReasonCodes = null; // (what is searched in the SAT filter)

        this.listOfReasonCodesForNoteView = this.getUniqueListOfSavedReasonCodesForNoteView(attrs.shapes);
        this.uniqueStringOfReasonCodes = this._getUniqueStringOfSavedReasonCodes(attrs.shapes);

        this.systemIsSetToFloatingCodes = fvChannel.request('applyFloatingReasonCodes'); // cache
        this.parentPageIsCold = this.parentPageIsCold || options.isColdPage;

        /*
        * This only applies to when creating
        * A result of only having the 'REDACTION_NOTE' type in the create note drop down menu
        * (and only having one model for both floating and non floating codes).
        * Floating redactions are not permitted on COLD pages. ... would be clearer to put on constructor (init called after parse)
        * FULL_PAGE_REDACTION clause: prevent the switch to floating for this note type ( may want clearer flag here )
        * */
        if ( options && options.isNew && this.systemIsSetToFloatingCodes && !this.parentPageIsCold && attrs.noteType !== 'FULL_PAGE_REDACTION' )
            attrs.noteType = 'FLOATING_REDACTION_NOTE';

        // set back isConverting flag post successful floating redaction note
        // ( pre-save it's note type is set to floating )
        if ( this.isConvertingToFloatingCodes && attrs.noteType === 'FLOATING_REDACTION_NOTE' ) {
            this.isConvertingToFloatingCodes = false;
        }

        return CoordinateNote.prototype.parse.apply(this, arguments);

    },
    /*
    * Note: this seems the place to returns either a rect or poly shape view when subclass the module.
    * Though now it's working and doing so may prove more complex.
    *  May make sense to move these constructor references off the model and into a factory in the application.
    * */
    shapeView: function(options) {

        var useFloating = this.isConvertingToFloatingCodes || ( this.get('noteType') === 'FLOATING_REDACTION_NOTE' && this.systemIsSetToFloatingCodes );
        return useFloating
            ? new FloatingRedactionShapeView(options)
            : new RedactionShapeView(options);

    },
    getShapeModel: function() {

        var useFloating = this.isConvertingToFloatingCodes || ( this.get('noteType') === 'FLOATING_REDACTION_NOTE' && this.systemIsSetToFloatingCodes );
        return useFloating
            ? FloatingCodesShapeModel
            : CoordinateRedactionShapeModel;
    },

    resetOnCancelChanges: function() {

        CoordinateNote.prototype.resetOnCancelChanges.apply( this, arguments );

        // reset this so when the canvas is redrawn, the other note type will be used
        this.isConvertingToFloatingCodes && ( this.isConvertingToFloatingCodes = false );

    },
    /*
    * Return a unique sorted, unique list of saved reason codes from all shapes to display on the note view.
    * If none exist, return null.
    * If shapes provided, use that instead of the shapes property on the model ( could come from parse ).
    * code here could be optimized but shouldn't impact performance, especially now caching on parse
    * */
    getUniqueListOfSavedReasonCodesForNoteView: function(shapes) {
        
        if (this.listOfReasonCodesForNoteView)
            return this.listOfReasonCodesForNoteView;

        // note: this top line can be gotten rid of ...
        shapes = shapes || this.get('shapes');
        if (!shapes || shapes.length < 1)
            return null;

        // Get obj of unique codes by their counts
        // DVBC-1382: depending on direction, may want diff obj / helper for this.
        // For time being this fn is a quick fix to avoid code duplication.
        var codesByCounts = this.getReasonCodeCounts(shapes);
        if (codesByCounts === null)
            return null;

        // Note: may want to make this html if need to get rid of parentheses (that are often used in codes)
        return this.getReasonCodeString(codesByCounts);

    },
    // Return obj of unique codes X count from the note's shapes
    // If none exist, return null
    getReasonCodeCounts: function(shapes) {

        var shapes = shapes || this.get('shapes');
        if (!shapes || shapes.length < 1)
            return null;

        // get non unique array of codes from all shapes
        var allCodes = _.chain( shapes )
            .map( function(s) {
                return _.pluck( s.reasonCodes, 'code' );
            })
            .flatten()
            .value();

        // create obj of unique codes X count
        // (maybe make this a diff obj ... for code reuse; later used in page/doc metrics for sorting, etc
        var codesByCounts = {};
        _.each( allCodes, function(c) {
            codesByCounts[c] = !_.contains( _.keys(codesByCounts), c )
                ? 1
                : codesByCounts[c] += 1;
        });

        return  _.keys(codesByCounts).length < 1
            ? null
            : codesByCounts;

    },
    // Take obj of codes by counts and return a string of them sorted by count (show in parenthesis), then by code
    getReasonCodeString: function(codesByCounts) {

        // Transform codesByCounts into format that facilitates sorting
        var arrayOfCodesObjsToSort = [];

        for (var code in codesByCounts) {
            arrayOfCodesObjsToSort.push( {
                code: code,
                count: codesByCounts[code]
            });
        }
        // Sort by both code and count
        var aSortedObjs = _.chain( arrayOfCodesObjsToSort )
            .sortBy( function(o ) {
                return o.code;
            })
            .sortBy( function(o) {
                return o.count * -1; //(descending)
            }).value();

        return _.map( aSortedObjs, function(o) {
            return o.code + ( o.count > 1 ? '(' + o.count + ')' : '' ) ;
        }).join(', ').trim();

    },

    // Add string of unique reason codes to search for in the SAT filter
    textToFilter: function() {
        return CoordinateNote.prototype.textToFilter.apply(this, arguments) + this._getUniqueStringOfSavedReasonCodes();
    },

    /*
    * Now used for text to filter -- if none, return empty string.
    * If shapes provided, use that instead of the shapes property on the model ( could come from parse ).
    * May want to search exactly what is printed in listOfReasonCodesForNoteView ....
    * */
    _getUniqueStringOfSavedReasonCodes: function(shapes) {

        if (this.uniqueStringOfReasonCodes)
            return this.uniqueStringOfReasonCodes;

        var shapes = shapes || this.get('shapes');
        if (!shapes || shapes.length < 1) return '';

        // return munged string of unique reason codes
        return _.chain( shapes )
            .map( function(s) {
                return _.pluck( s.reasonCodes, 'code' );
            })
            .flatten()
            .uniq()
            .value().join('');
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/drawable/coordinate/redaction/redaction.js
 ** module id = 149
 ** module chunks = 0
 **/